import Vue from 'vue'

import Alert from '@/components/Alert'
import AreaToggle from '@/components/AreaToggle'
import Badge from '@/components/Badge'
import Collapse from '@/components/Collapse'
import ContactToggle from '@/components/ContactToggle'
import CountrySelect from '@/components/CountrySelect'
import DataTable from '@/components/DataTable'
import Dropdown from '@/components/Dropdown'
import FlyoutMenu from '@/components/FlyoutMenu'
import Loading from '@/components/Loading'
import LogoFleetbeacon from '@/components/LogoFleetbeacon'
import LogoPortal from '@/components/LogoPortal'
import LogoRadar from '@/components/LogoRadar'
import MenuIcon from '@/components/MenuIcon'
import Modal from '@/components/Modal'
import NavTabs from '@/components/NavTabs'
import PageHeader from '@/components/PageHeader'
import Pagination from '@/components/Pagination'
import RadioGrid from '@/components/RadioGrid'
import RadioGroup from '@/components/RadioGroup'
import RadioStack from '@/components/RadioStack'
import ScheduleToggle from '@/components/ScheduleToggle'
import Toggle from '@/components/Toggle'
import Topbar from '@/components/Topbar'
import Validations from '@/components/Validations'
import VehicleToggle from '@/components/VehicleToggle'

Vue.component('alert', Alert)
Vue.component('AreaToggle', AreaToggle)
Vue.component('badge', Badge)
Vue.component('Collapse', Collapse)
Vue.component('contact-toggle', ContactToggle)
Vue.component('country-select', CountrySelect)
Vue.component('data-table', DataTable)
Vue.component('dropdown', Dropdown)
Vue.component('flyout-menu', FlyoutMenu)
Vue.component('LogoFleetbeacon', LogoFleetbeacon)
Vue.component('LogoPortal', LogoPortal)
Vue.component('LogoRadar', LogoRadar)
Vue.component('Loading', Loading)
Vue.component('menu-icon', MenuIcon)
Vue.component('Modal', Modal)
Vue.component('NavTabs', NavTabs)
Vue.component('PageHeader', PageHeader)
Vue.component('Pagination', Pagination)
Vue.component('radio-grid', RadioGrid)
Vue.component('radio-group', RadioGroup)
Vue.component('radio-stack', RadioStack)
Vue.component('schedule-toggle', ScheduleToggle)
Vue.component('toggle', Toggle)
Vue.component('topbar', Topbar)
Vue.component('validations', Validations)
Vue.component('vehicle-toggle', VehicleToggle)

/**
 * Third-Party Components
 */

import Currency from 'vue-money-format'
Vue.component('currency', Currency)

import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

import DatePicker from 'v-calendar/lib/components/date-picker.umd'
Vue.component('DatePicker', DatePicker)